import { QuoteRequestStatusType } from '../types/quote.type';
import { IResponse } from './helper.interface';

export interface IRenewal {
    policy_diff?: IPolicyDiff;
    quote_id?: string;
    quote_request_id?: string;
    renewal_date?: string;
    schedule_id?: number;
    status?: QuoteRequestStatusType;
}


export type IRenewalUpdateResponse = IResponse

interface IPolicyDiff {
    vehicles?: Array<unknown>;
    contents: Array<unknown>;
    buildings: Array<unknown>;
    motorcycles: Array<unknown>;
    caravans: Array<unknown>;
    specified_items: Array<unknown>;
    all_risk: Array<unknown>;
    insurer_ratings: Array<unknown>;
    schedule?: ISchedule;
}

interface ISchedule {
    assistance_benefits: any;
    more_than_cover: any;
    personal_liability: any;
    premium_summary: IPremiumSummary;
    total_premium: ITotalPremium;
}

interface ITotalPremium {
    current: number;
    diff: number;
    renewal: number;
}
interface IPremiumSummary {
    admin_fee: IAdminFee;
    sasria: ISasria;
}

interface IAdminFee {
    current: number;
    diff: number;
    renewal: number;
}

interface ISasria {
    current: number;
    diff: number;
    renewal: number;
}